<section *ngIf="form" class="panel inner-panel">
  <div [formGroup]="formBilling" class="panel-wrapper">
    <div formArrayName="intervals" class="panel-collection">
      <div [formGroupName]="$index" *ngFor="let item of collectionOfBillingInterval; let $index=index;" [class]="'panel-inner'" [ngClass]="{'billing-interval--first': $index == 0}">
        <div class="panel-head">
          <mat-form-field class="custom-mat-form-field size size1of1">
            <mat-label>Billing Frequency</mat-label>
            <mat-select formControlName="billingFrequencyDefault" (selectionChange)="onChangeBillingFrequency($event.value, $index)" name="frequency">
              <mat-option *ngFor="let frequency of collectionOfBillingFrequency" [value]="frequency.value">{{frequency.label}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="panel-action">
            <button mat-stroked-button (click)="removeBillingPeriod($index)" color="primary" disableRipple="true" class="custom-mat-button button-remove button-remove-block">Remove Interval</button>
          </div>
        </div>
        <div class="panel-body">
          <div [@onRowStatusChange]='statusBillingFrequency' class="form-row row-custom-billing-frequency">
            <mat-form-field class="custom-mat-form-field field-frequency-unit">
              <mat-label>Frequency Unit</mat-label>
              <mat-select required formControlName="billingFrequencyUnit" (selectionChange)="onChangeBillingFrequencyUnit($event.value, $index)" class="custom-mat-select">
                <mat-option *ngFor="let frequencyUnit of collectionOfBillingFrequencyUnit" [value]="frequencyUnit.value" class="custom-mat-option">{{frequencyUnit.label}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field floatLabel="always" class="custom-mat-form-field field-frequency-value">
              <mat-label>Frequency Length</mat-label>
              <input matInput required formControlName="billingFrequencyLength" type="number" name="intervalValue" placeholder="1">
            </mat-form-field>
          </div>
          <!-- Week Options -->
          <div [@onRowStatusChange]='statusBillingFrequencyWeek' class="form-row">
            <mat-form-field class="custom-mat-form-field size size1of1">
              <mat-label>On</mat-label>
              <mat-select formControlName="frequencyWeekOptionDefault" (selectionChange)="onChangeFrequencyWeekOption($event.value)" class="custom-mat-select">
                <mat-option *ngFor="let item of collectionOfFrequencyWeekOption" [value]="item.value" class="custom-mat-option">{{item.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div [@onRowStatusChange]='statusBillingFrequencyWeekDays' class="form-row row-calendar-week-days">
            <div class="form-row-inner">
              <mat-button-toggle-group multiple="true" class="custom-mat-button-toggle-group">
                <mat-button-toggle value="sunday" class="custom-mat-button-toggle"><span class="mobile--only">S</span><span>Sunday</span></mat-button-toggle>
                <mat-button-toggle value="monday" class="custom-mat-button-toggle"><span class="mobile--only">M</span><span>Monday</span></mat-button-toggle>
                <mat-button-toggle value="tuesday" class="custom-mat-button-toggle"><span class="mobile--only">T</span><span>Tuesday</span></mat-button-toggle>
                <mat-button-toggle value="wednesday" class="custom-mat-button-toggle"><span class="mobile--only">W</span><span>Wednesday</span></mat-button-toggle>
                <mat-button-toggle value="thursday" class="custom-mat-button-toggle"><span class="mobile--only">T</span><span>Thursday</span></mat-button-toggle>
                <mat-button-toggle value="friday" class="custom-mat-button-toggle"><span class="mobile--only">F</span><span>Friday</span></mat-button-toggle>
                <mat-button-toggle value="saturday" class="custom-mat-button-toggle"><span class="mobile--only">S</span><span>Saturday</span></mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <!-- Month Options -->
          <div [@onRowStatusChange]='statusBillingFrequencyMonth' class="form-row">
            <mat-form-field class="custom-mat-form-field size size1of1">
              <mat-label>On</mat-label>
              <mat-select formControlName="frequencyMonthOptionDefault" (selectionChange)="onChangeFrequencyMonthOption($event.value, $index)" class="custom-mat-select">
                <mat-option *ngFor="let item of collectionOfFrequencyMonthOption" [value]="item.value" class="custom-mat-option">{{item.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div [@onRowStatusChange]='statusBillingFrequencyMonthDays' class="form-row row-calendar-days">
            <div class="form-row-inner">
              <mat-button-toggle-group multiple="true" class="custom-mat-button-toggle-group group-calendar-days">
                <mat-button-toggle *ngFor="let day of collectionOfMonthDay" value="day" class="custom-mat-button-toggle">{{day}}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div [@onRowStatusChange]='statusBillingFrequencyMonthDate' class="form-row">
            <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of2">
              <mat-label>On the</mat-label>
              <mat-select formControlName="frequencySubscribeOnUnitDefault" class="custom-mat-select">
                <mat-option *ngFor="let item of collectionOfSubscribeOn" [value]="item.value" class="custom-mat-option">{{ item.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="custom-mat-form-field margin m__00000016 size size1of2">
              <mat-select formControlName="frequencySubscribeOnValueDefault" class="custom-mat-select">
                <mat-option *ngFor="let item of collectionOfSubscribeOnOptions" [value]="item.value" class="custom-mat-option">{{ item.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Year Options -->
          <div [@onRowStatusChange]='statusBillingFrequencyYear' class="form-row">
            <mat-form-field class="custom-mat-form-field size size1of1">
              <mat-label>On</mat-label>
              <mat-select formControlName="frequencyYearOptionDefault" (selectionChange)="onChangeFrequencyYearOption($event.value)" class="custom-mat-select">
                <mat-option *ngFor="let item of collectionOfFrequencyYearOption" [value]="item.value" class="custom-mat-option">{{item.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div [@onRowStatusChange]='statusBillingFrequencyYearMonth' class="form-row row-calendar-months">
            <div class="form-row-inner">
              <mat-button-toggle-group multiple="true" class="custom-mat-button-toggle-group group-calendar-months">
                <mat-button-toggle value="01" class="custom-mat-button-toggle">Jan</mat-button-toggle>
                <mat-button-toggle value="02" class="custom-mat-button-toggle">Feb</mat-button-toggle>
                <mat-button-toggle value="03" class="custom-mat-button-toggle">Mar</mat-button-toggle>
                <mat-button-toggle value="04" class="custom-mat-button-toggle">Apr</mat-button-toggle>
                <mat-button-toggle value="05" class="custom-mat-button-toggle breakline">May</mat-button-toggle>
                <mat-button-toggle value="06" class="custom-mat-button-toggle">Jun</mat-button-toggle>
                <mat-button-toggle value="07" class="custom-mat-button-toggle">Jul</mat-button-toggle>
                <mat-button-toggle value="08" class="custom-mat-button-toggle">Ago</mat-button-toggle>
                <mat-button-toggle value="09" class="custom-mat-button-toggle breakline">Sep</mat-button-toggle>
                <mat-button-toggle value="10" class="custom-mat-button-toggle">Oct</mat-button-toggle>
                <mat-button-toggle value="11" class="custom-mat-button-toggle">Nov</mat-button-toggle>
                <mat-button-toggle value="12" class="custom-mat-button-toggle">Dec</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div [@onRowStatusChange]='statusBillingFrequencyYearDate' class="form-row">
            <div class="form-row-inner size size1of2">
              <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1">
                <mat-label>On the</mat-label>
                <mat-select formControlName="frequencySubscribeOnUnitDefault" (selectionChange)="onChangeSubscribeOnUnit($event.value, $index)" class="custom-mat-select">
                  <mat-option *ngFor="let item of collectionOfSubscribeOn" [value]="item.value" class="custom-mat-option">{{ item.label }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-row-inner margin m__00000016 size size1of2">
              <mat-form-field [@onColumnStatusChange]='statusColumnSubscribeOnDate' class="custom-mat-form-field size size1of2">
                <mat-label>Day</mat-label>
                <input matInput>
              </mat-form-field>
              <mat-form-field [@onColumnStatusChange]='statusColumnSubscribeOnDate' class="custom-mat-form-field size size1of2">
                <mat-label>Month</mat-label>
                <mat-select class="custom-mat-select">
                  <mat-option *ngFor="let item of collectionOfMonth" [value]="item.value" class="custom-mat-option">{{ item.label }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field [@onColumnStatusChange]='statusColumnSubscribeOnUnit' class="custom-mat-form-field size size1of1">
                <mat-select formControlName="frequencySubscribeOnValueDefault" class="custom-mat-select">
                  <mat-option *ngFor="let item of collectionOfSubscribeOnOptions" [value]="item.value" class="custom-mat-option">{{ item.label }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
